import { legal } from '@getpopsure/private-constants';
import { MultiDropzone } from '@popsure/dirty-swan';
import { NavButton } from 'components/NavButton';
import QuestionnaireWrapper from 'components/questionnaireForms/QuestionnaireWrapper';
import { FormEvent } from 'react';
import { TFunction, Trans } from 'shared/i18n';
import { UploadedFile } from 'shared/models/types';
import { isMobileApp } from 'shared/util/isMobileApp';

interface Props {
  handleSubmit: (e: FormEvent) => void;
  t: TFunction;
  submissionLoading?: boolean;
  onFileSelect: (files: File[]) => void;
  onRemoveFile: (id: string) => void;
  uploadedFiles: UploadedFile[];
  uploadLoading: boolean;
  isSubmitValid: boolean;
  error?: string;
}

export const DentalClaimsUploadDocumentsView = ({
  handleSubmit,
  onFileSelect,
  onRemoveFile,
  uploadedFiles,
  t,
  submissionLoading,
  uploadLoading,
  isSubmitValid,
  error,
}: Props) => (
  <QuestionnaireWrapper
    question={t('claims.dental.uploadDocuments.question', 'Upload documents')}
    description={t(
      'claims.dental.uploadDocuments.description',
      'Upload the invoice showing the breakdown of costs and the cost plan (if it’s a major treatment).'
    )}
    onSubmit={handleSubmit}
    additionalInfo={{
      title: t(
        'claims.dental.uploadDocuments.additionalInfo.title',
        'Are photos accepted?'
      ),
      description: t(
        'claims.dental.uploadDocuments.additionalInfo.description',
        'We accept both scanned documents and photos of documents. Make sure that **all pages of the invoice** are included and the text is readable before submitting. '
      ),
    }}
    validForSubmission={isSubmitValid}
    loading={uploadLoading || submissionLoading}
    error={error}
  >
    <div className="wmx6">
      {isMobileApp && <NavButton title="Previous question" renderInPortal />}

      <MultiDropzone
        onFileSelect={onFileSelect}
        uploadedFiles={uploadedFiles}
        uploading={uploadLoading}
        onRemoveFile={onRemoveFile}
      />
    </div>
    <Trans i18nKey="claims.dental.uploadDocuments.agreement">
      <p className="mt24 p-p">
        By uploading any documents you agree to our{' '}
        <a
          className="p-a"
          href={legal.declarationDataProtection}
          target="_blank"
          rel="noopener noreferrer"
        >
          data processing agreement
        </a>
        .
      </p>
    </Trans>
  </QuestionnaireWrapper>
);
